import React, { useState } from "react";
import SupplementsList from "./SupplementsList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PizzaSupplements from "./PizzaSupplements";

const ItemAdditions = ({
  t,
  itemInstructions,
  selectedInstructions,
  onSelectInstructions,
  selectedItemSupplements,
  selectedSupplements,
  onSelectSupplement,
  currentFreeInstruction,
  changeFreeInstruction,
  removeSelectedSupplement,
  isPizza,
}) => {
  const [freeInstruction, setFreeInstruction] = useState(
    currentFreeInstruction
  );

  const onChangeFreeInstruction = (e) => {
    const { value } = e.currentTarget;
    setFreeInstruction(value);
    changeFreeInstruction(value);
  };

  return (
    <div className={"additions"}>
      <h3>{t("add_item_modal.additions")}</h3>
      {itemInstructions && itemInstructions.length > 0 && (
        <div className={"supplements"}>
          <div className={"supplements-title"}>
            {t("add_item_modal.instructions")}
          </div>
          <SupplementsList
            supplementsList={itemInstructions}
            selectedSupplements={selectedInstructions}
            onSelect={onSelectInstructions}
          />
        </div>
      )}

      {isPizza &&
        selectedItemSupplements &&
        selectedItemSupplements.length > 0 && (
          <PizzaSupplements
            supplements={selectedItemSupplements}
            selectedSupplements={selectedSupplements}
            onSelect={onSelectSupplement}
            removeSelectedSupplement={removeSelectedSupplement}
          />
        )}

      {!isPizza &&
        selectedItemSupplements &&
        selectedItemSupplements.length > 0 && (
          <div className={"supplements"}>
            <div className={"supplements-title"}>
              {t("add_item_modal.supplements")}
            </div>
            <SupplementsList
              supplementsList={selectedItemSupplements}
              selectedSupplements={selectedSupplements}
              onSelect={onSelectSupplement}
            />
          </div>
        )}

      <div className={"free-instruction-block"}>
        <div className={"free-instruction-title"}>
          {t("add_item_modal.free_instruction")}
        </div>
        <div className={"free-instruction-input-block"}>
          <input
            type={"text"}
            value={freeInstruction}
            onChange={onChangeFreeInstruction}
            placeholder={t("add_item_modal.free_instruction_placeholder")}
          />
          {currentFreeInstruction && (
            <div
              className={"clear-search"}
              onClick={() => {
                setFreeInstruction("");
                changeFreeInstruction("");
              }}
            >
              <FontAwesomeIcon icon="times" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ItemAdditions;
